import type { OMSConfig, StrategyEvaluator, SignalResult, StrategyContext } from '../types';
import { ensureFlatOpts } from '../../analysis/trend-evaluator';

export const evaluateConnectingDots5MLows: StrategyEvaluator = (data: any, currentUnixTime: number, config: OMSConfig, context: StrategyContext): SignalResult | null => {
    if (!data || !context.liveIndicators) return null;

    const { indLiveTop1Ce, indLiveTop1Pe, indLiveTop2Ce, indLiveTop2Pe, top1, top2 } = context.liveIndicators;
    
    if (!top1 || (!indLiveTop1Ce && !indLiveTop1Pe)) return null;

    const liveRawOptsArr = context.chain || [];
    const flatOpts = ensureFlatOpts(liveRawOptsArr);

    const getLowsBrokenCount = (strike: number, ceInd: any, peInd: any) => {
        if (!ceInd && !peInd) return { ceBroken: 0, peBroken: 0, total: 1 };

        const ceRow = flatOpts.find((o: any) => o.strike === strike && o.type === 'CE');
        const peRow = flatOpts.find((o: any) => o.strike === strike && o.type === 'PE');
        
        const ceLtp = ceRow ? ceRow.ltp : 0;
        const peLtp = peRow ? peRow.ltp : 0;

        const lowsList = [
            { ce: ceInd?.first5Min?.low, pe: peInd?.first5Min?.low },
        ];

        const ceBroken = lowsList.filter(l => l.ce && ceLtp < l.ce).length;
        const peBroken = lowsList.filter(l => l.pe && peLtp < l.pe).length;

        return { ceBroken, peBroken };
    };

    const t1 = getLowsBrokenCount(top1.strike, indLiveTop1Ce, indLiveTop1Pe);
    const t2 = top2 && (indLiveTop2Ce || indLiveTop2Pe)
        ? getLowsBrokenCount(top2.strike, indLiveTop2Ce, indLiveTop2Pe)
        : { ceBroken: 0, peBroken: 0 };

    let status = 'Sideways';
    if (t1.peBroken > t1.ceBroken && t2.peBroken > t2.ceBroken) status = 'Bull';
    else if (t1.ceBroken > t1.peBroken && t2.ceBroken > t2.peBroken) status = 'Bear';

    if (status === 'Sideways') return null;

    const entryStrike = top1.strike;
    let entryPrice = 0;
    
    const optionType = status === 'Bull' ? 'CE' : 'PE';
    const atmRow = flatOpts.find((r: any) => r.strike === entryStrike && r.type === optionType);
    
    if (atmRow) {
        entryPrice = atmRow.ltp || atmRow.close || atmRow.price || 0;
        if (entryPrice > 0) {
            return {
                trade_type: status === 'Bull' ? 'BULL' : 'BEAR',
                strike: entryStrike,
                option_type: optionType,
                entry_price: entryPrice,
                remarks: status === 'Bull' ? `PE 5m Low Broken` : `CE 5m Low Broken`
            };
        }
    }

    return null;
};
